import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { policies as permessi } from "../../const/policies"
import { useNavigate } from 'react-router-dom';
import useMobileDetection from '../../Hooks/useMobileDetection';
import useGenerateQrCode from '../../Hooks/useGenerateQrCode';
import { GenerateQrCodeStanza } from '../../const/urlAction';
import { faBan, faPen, faQrcode, faTrash, faRotateRight, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from "react-i18next";
import {
  Typography, Menu, Box, IconButton, Tooltip,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider
} from "@mui/material";
import { handleDialogToEditStanza, handleDialogToEnableDisableStanza } from "./operations/handleDialogEditStanza";
import { dialogPageTypes } from "../../const/dialogPageTypes";
import handlerButtonRoom from "../../functions/boxButton/handlerButtonRoom";
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { setScrollY } from "../../redux/reducers/scroll-reducer";


const ButtonBoxStanze = ({ row: rowInfo, inSubmenu = false }) => {
  const configuration = useSelector((state) => state.configurations.configurazioniGlobali);
  const { enableQrCodeScanner, qrCodeDinamico } = configuration;
  const state = useSelector((state) => state.userDate);
  const { policies, responsabileEdificio } = state;
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const viewState = useSelector((state) => state.viewState);
  const isSalaRiunione = rowInfo?.isSalaRiunione;
  const idStanza = rowInfo?.id;
  const isMobile = useMobileDetection(600);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const menuOpen = Boolean(menuAnchorEl);

  const handleMenuClick = (event) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    dispatch(setScrollY(document.querySelector("main.MuiBox-root").scrollTop));
  };

  const handleDownloadQrCode = useGenerateQrCode(setIsLoading, GenerateQrCodeStanza);

  let icon = handlerButtonRoom(rowInfo.idTipologiaStanza);
  const actionButtonStyle = {
    border: "1px solid #dcdcdc",
    borderRadius: "4px",
    padding: "4px 8px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    backgroundColor: "#eae5e591",
    cursor: "pointer",
    minWidth: "78px",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
      borderColor: "#3e6bb4",
    },
  };
  return (
    <>
      {inSubmenu ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', pb: 1 }}>
          {policies.indexOf(permessi.zoneInserimentoModifica) !== -1 && (
            <MenuItem onClick={(event) => handleDialogToEditStanza({ type: "edit", row: rowInfo }, dispatch, event)}>
              <ListItemIcon><FontAwesomeIcon icon={faPen} /></ListItemIcon>
              <ListItemText>{t("edit")}</ListItemText>
            </MenuItem>
          )}
          {policies.indexOf(permessi.stanzeEliminazioneRipristino) !== -1 && (
            <MenuItem onClick={(event) => handleDialogToEditStanza({ type: "delete", row: rowInfo }, dispatch, event)}>
              <ListItemIcon>
                {rowInfo?.dispositivoAbilitato ? <FontAwesomeIcon icon={faBan} /> : <FontAwesomeIcon icon={faTrash} />}
              </ListItemIcon>
              <ListItemText>{!rowInfo?.dataDel ? t("delete") : t("enable")}</ListItemText>
            </MenuItem>
          )}
          {enableQrCodeScanner && !qrCodeDinamico &&
            (policies.indexOf(permessi.postazioniDownloadQRCode) !== -1 || responsabileEdificio.length > 0) && (
              <>
                <MenuItem onClick={() => handleDownloadQrCode(rowInfo.id)}>
                  <ListItemIcon><FontAwesomeIcon icon={faQrcode} /></ListItemIcon>
                  <ListItemText>{t("download_qr_code")}</ListItemText>
                </MenuItem>
                <Divider />
              </>
            )}
          {(policies.indexOf(permessi.edificiAbilitaDisabilita) !== -1 || responsabileEdificio.length > 0) && (
            <>
              <MenuItem onClick={(event) => handleDialogToEnableDisableStanza({ dialogPageType: dialogPageTypes.stanze, dialogType: "disableRangeData", rowInfo }, dispatch, event)}>
                <ListItemIcon><FontAwesomeIcon icon={faBan} /></ListItemIcon>
                <ListItemText>{t("disable_v3")}</ListItemText>
              </MenuItem>
              <MenuItem onClick={(event) => handleDialogToEnableDisableStanza({ dialogPageType: dialogPageTypes.stanze, dialogType: "ripristinaAll", rowInfo }, dispatch, event)}>
                <ListItemIcon><FontAwesomeIcon icon={faRotateRight} /></ListItemIcon>
                <ListItemText>{t("restore_v2")}</ListItemText>
              </MenuItem>
            </>
          )}
          {!isSalaRiunione && policies.indexOf(permessi.stanzeVisualizzazione) !== -1 && (
            <MenuItem onClick={() => navigate("" + idStanza)}>
              <ListItemIcon><FontAwesomeIcon icon={faArrowRight} /></ListItemIcon>
              <ListItemText>{t("goToworkstations")}</ListItemText>
            </MenuItem>
          )}
        </Box>
      ) : !isMobile && !viewState ? (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
            <Tooltip title={t("actions")}>
              <IconButton
                onClick={handleMenuClick}
                size="small"
                sx={{
                  mr: 2,
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                }}
                aria-controls={menuOpen ? 'actions-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={menuOpen ? 'true' : undefined}
              >
                <FontAwesomeIcon icon={faEllipsisV} size="lg" />
              </IconButton>
            </Tooltip>
          </Box>
          <Menu
            anchorEl={menuAnchorEl}
            id="actions-menu"
            open={menuOpen}
            onClose={handleMenuClose}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            slotProps={{
              paper: {
                elevation: 2,
                sx: {
                  mt: 1,
                  borderRadius: "10px",
                  minWidth: 180,
                },
              },
            }}
          >
            {policies.indexOf(permessi.zoneInserimentoModifica) !== -1 && (
              <MenuItem
                onClick={(event) =>
                  handleDialogToEditStanza({ type: "edit", row: rowInfo }, dispatch, event)
                }
              >
                <ListItemIcon>
                  <FontAwesomeIcon icon={faPen} />
                </ListItemIcon>
                <ListItemText>{t("edit")}</ListItemText>
              </MenuItem>
            )}
            {policies.indexOf(permessi.stanzeEliminazioneRipristino) !== -1 && (
              <MenuItem
                onClick={(event) =>
                  handleDialogToEditStanza(
                    { type: "delete", row: rowInfo },
                    dispatch,
                    event
                  )
                }
              >
                <ListItemIcon>
                  {rowInfo?.dispositivoAbilitato ? (
                    <FontAwesomeIcon icon={faBan} />
                  ) : (
                    <FontAwesomeIcon icon={faTrash} />
                  )}
                </ListItemIcon>
                <ListItemText>
                  {!rowInfo?.dataDel ? t("delete") : t("enable")}
                </ListItemText>
              </MenuItem>
            )}
            {enableQrCodeScanner &&
              !qrCodeDinamico &&
              (policies.indexOf(permessi.postazioniDownloadQRCode) !== -1 ||
                responsabileEdificio.length > 0) && (
                <>
                  <MenuItem onClick={() => handleDownloadQrCode(rowInfo.id)}>
                    <ListItemIcon>
                      <FontAwesomeIcon icon={faQrcode} />
                    </ListItemIcon>
                    <ListItemText>{t("download_qr_code")}</ListItemText>
                  </MenuItem>
                  {!isMobile && <Divider />}
                </>
              )}

            {(policies.indexOf(permessi.edificiAbilitaDisabilita) !== -1 ||
              responsabileEdificio.length > 0) && (
                <MenuItem
                  onClick={(event) =>
                    handleDialogToEnableDisableStanza(
                      {
                        dialogPageType: dialogPageTypes.stanze,
                        dialogType: "disableRangeData",
                        rowInfo,
                      },
                      dispatch,
                      event
                    )
                  }
                >
                  <ListItemIcon>
                    <FontAwesomeIcon icon={faBan} />
                  </ListItemIcon>
                  <ListItemText>{t("disable_v3")}</ListItemText>
                </MenuItem>
              )}

            {(policies.indexOf(permessi.edificiAbilitaDisabilita) !== -1 ||
              responsabileEdificio.length > 0) && (
                <>
                  <MenuItem
                    onClick={(event) =>
                      handleDialogToEnableDisableStanza(
                        {
                          dialogPageType: dialogPageTypes.stanze,
                          dialogType: "ripristinaAll",
                          rowInfo,
                        },
                        dispatch,
                        event
                      )
                    }
                  >
                    <ListItemIcon>
                      <FontAwesomeIcon icon={faRotateRight} />
                    </ListItemIcon>
                    <ListItemText>{t("restore_v2")}</ListItemText>
                  </MenuItem>
                  {!isMobile && <Divider />}
                </>
              )}
            {!isSalaRiunione &&
              policies.indexOf(permessi.stanzeVisualizzazione) !== -1 && (
                <>
                  <MenuItem onClick={() => navigate("" + idStanza)}>
                    <ListItemIcon>
                      <FontAwesomeIcon icon={faArrowRight} />
                    </ListItemIcon>
                    <ListItemText>{t("goToworkstations")}</ListItemText>
                  </MenuItem>

                </>
              )}

          </Menu>
        </>
      ) : (
        <>
          {(policies.indexOf(permessi.edificiAbilitaDisabilita) !== -1 ||
            responsabileEdificio.length > 0) && (
              <GridActionsCellItem
                sx={{ '& .MuiTouchRipple-root': { display: 'none' } }}
                className={isMobile || viewState ? "button-ButtonBox-Mobile forceNoPaddingLeft" : ""}
                icon={
                  <Tooltip title={t("disable_v3")}>
                    <div style={actionButtonStyle}>
                      <>
                        <FontAwesomeIcon icon={faBan} size="xs" style={{ color: "#636161", marginRight: "3px" }} />
                        <Typography sx={{ fontSize: 10, color: "#636161" }}>{t("disable_v3")}</Typography>
                      </>
                    </div>
                  </Tooltip>
                }
                label={t("disable_v3")}
                onClick={(event) =>
                  handleDialogToEnableDisableStanza({ dialogPageType: dialogPageTypes.stanze, dialogType: "disableRangeData", rowInfo }, dispatch, event)
                }
              />
            )}

          {(policies.indexOf(permessi.edificiAbilitaDisabilita) !== -1 ||
            responsabileEdificio.length > 0) && (
              <GridActionsCellItem
                sx={{ '& .MuiTouchRipple-root': { display: 'none' } }}
                className={isMobile ? "button-ButtonBox-Mobile forceNoPaddingLeft" : ""}
                icon={
                  <Tooltip title={t("restore_v2")}>
                    <div style={actionButtonStyle}>
                      <FontAwesomeIcon icon={faRotateRight} size="xs" style={{ color: "#636161", marginRight: "3px" }} />
                      <Typography sx={{ fontSize: 10, color: "#636161" }}>{t("restore_v2")}</Typography>
                    </div>
                  </Tooltip>
                }
                label={t("restore_v2")}
                onClick={(event) =>
                  handleDialogToEnableDisableStanza({ dialogPageType: dialogPageTypes.stanze, dialogType: "ripristinaAll", rowInfo }, dispatch, event)
                }
              />
            )}
          {policies.indexOf(permessi.stanzeEliminazioneRipristino) !== -1 && (
            <GridActionsCellItem
              sx={{ '& .MuiTouchRipple-root': { display: 'none' } }}
              className={isMobile ? "button-ButtonBox-Mobile forceNoPaddingLeft" : ""}
              icon={
                <Tooltip title={!rowInfo?.dataDel ? t("delete") : t("enable")}>
                  <div style={actionButtonStyle}>
                    {rowInfo?.dispositivoAbilitato
                      ?
                      <FontAwesomeIcon
                        icon={faBan}
                        style={{ fontSize: 25 }}
                        className="pathIcon"
                      />
                      :
                      <>
                        <FontAwesomeIcon icon={faTrash} size="xs" style={{ color: "#636161", marginRight: "3px" }} />

                        <Typography sx={{ fontSize: 10, color: "#636161" }}>{t("delete_v3")}</Typography>
                      </>
                    }</div>
                </Tooltip>
              }
              label={t("delete")}
              onClick={(event) => handleDialogToEditStanza({ type: "delete", row: rowInfo }, dispatch, event)}
            />
          )}
          {enableQrCodeScanner && !qrCodeDinamico &&
            (policies.indexOf(permessi.postazioniDownloadQRCode) !== -1 ||
              responsabileEdificio.length > 0) && (
              <GridActionsCellItem
                sx={{ '& .MuiTouchRipple-root': { display: 'none' } }}
                className={isMobile ? "button-ButtonBox-Mobile forceNoPaddingLeft" : ""}
                icon={
                  <Tooltip title={t("download_qr_code")}>
                    <div style={actionButtonStyle}>
                      <>
                        <FontAwesomeIcon icon={faQrcode} size="xs" style={{ color: "#636161", marginRight: "3px" }} />
                        <Typography sx={{ fontSize: 10, color: "#636161" }}>{t("download_qr_code")}</Typography>
                      </>
                    </div>
                  </Tooltip>
                }
                label={t("download_qr_code")}
                onClick={() => handleDownloadQrCode(rowInfo.id)}
              />
            )}


        </>
      )}
    </>
  );
};

export default ButtonBoxStanze;
